import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "../site/Reveal";
import { Eyebrow } from "./Intro";
import { RANGES } from "../../data/products";

const Tile = ({ r, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
  >
    <Link to={`/products/${r.slug}`} data-testid={`platform-card-${r.slug}`} className="group relative block h-[460px] md:h-[560px] overflow-hidden rounded-[10px] bg-[var(--forest)]">
      <img src={r.tile} alt={r.species} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,32,21,0.95)] via-[rgba(0,40,26,0.45)] to-transparent transition-opacity duration-500" />
      <div className="absolute inset-x-0 bottom-0 p-7 md:p-8 text-white">
        <p className="text-[12px] font-bold uppercase tracking-[0.2em] text-[var(--lime)]">{r.species}</p>
        <h3 className="font-display text-4xl md:text-5xl mt-2">{r.name}</h3>
        <p className="text-[#DCEBE0] mt-2">{r.category}</p>
        <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-500">
          <ul className="overflow-hidden space-y-1.5 text-sm text-white/90">
            {r.benefits.map((b) => <li key={b} className="flex items-center gap-2 first:mt-4"><Check size={14} className="text-[var(--lime)]" />{b}</li>)}
          </ul>
        </div>
        <div className="mt-6 pt-5 border-t border-white/20 flex items-end justify-between">
          <span>
            <span className="block font-display text-3xl text-[var(--lime)]">{r.stats[0].v}</span>
            <span className="block text-xs text-white/75 max-w-[13rem]">{r.stats[0].l}</span>
          </span>
          <span className="grid place-items-center h-12 w-12 rounded-full bg-white text-[var(--forest)] transition-transform duration-300 group-hover:translate-x-1 group-hover:bg-[var(--lime)]"><ArrowRight size={20} /></span>
        </div>
      </div>
    </Link>
  </motion.div>
);

export const Solutions = () => (
  <section id="ranges" data-testid="platforms-section" className="bg-white">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-20 md:py-28">
      <div className="grid lg:grid-cols-12 gap-6 items-end mb-12">
        <div className="lg:col-span-7">
          <Eyebrow>Our solutions</Eyebrow>
          <Reveal as="h2" className="font-display text-3xl sm:text-4xl lg:text-[3.4rem] leading-[1.08] text-[var(--forest)] mt-6">
            Three platforms for the species you feed.
          </Reveal>
        </div>
        <p className="lg:col-span-5 text-[var(--muted)] text-base md:text-lg leading-relaxed">
          Palatability for ruminants, attractants for aquaculture and performance solutions for poultry — each backed by dosage guidance and technical data.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {RANGES.map((r, i) => <Tile key={r.slug} r={r} i={i} />)}
      </div>
    </div>
  </section>
);
